// extracted by mini-css-extract-plugin
export default {"globeIcon":"ServicesOffered_globeIcon__BzQn4","keychainIcon":"ServicesOffered_keychainIcon__98Soz","luggageIcon":"ServicesOffered_luggageIcon__uENeX"};